import { NavLink } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/log", label: "Daily" },
  { to: "/weekly", label: "Weekly" },
  { to: "/labs", label: "Labs" },
  { to: "/finance", label: "Finance" },
  { to: "/budget", label: "Budget" },
  { to: "/plan", label: "Plan" },
];

export function Nav() {
  const { logout } = useAuth();

  return (
    <header className="sticky top-0 z-10 bg-bg/95 backdrop-blur border-b border-border">
      <nav className="max-w-5xl mx-auto px-3 sm:px-4 py-2.5 sm:py-3 flex items-center gap-2 overflow-x-auto">
        <span className="font-semibold text-accent shrink-0 mr-1">life</span>
        <div className="flex gap-1 flex-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `px-2.5 sm:px-3 py-1.5 rounded-lg text-sm whitespace-nowrap ${
                  isActive ? "bg-card text-white" : "text-muted hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <button
          onClick={logout}
          className="text-sm text-muted hover:text-white shrink-0 px-2"
          title="Sign out"
        >
          Sign out
        </button>
      </nav>
    </header>
  );
}
